import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IProductSuggestResponseHistory } from '../models/ProductSuggestListModel'

export class SuggestHistoryApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/productSuggest/listSuggestHistoryById',
      requesterInfo,
    })
  }

  public async historyByID(request: number): Promise<IProductSuggestResponseHistory[]> {
    return await this.postAsync<IProductSuggestResponseHistory[]>(request)
  }
}
